module.exports = __webpack_public_path__ + "static/media/project-diagram.ec24e8a7.svg";